import PrivateRoute from 'components/private-route';
import * as routes from 'config/routes';
import frontload from 'hoc/frontload';
import { DI } from 'modules';
import React from 'react';
import {
  matchPath,
  Redirect,
  Route,
  Switch,
  withRouter
} from 'react-router-dom';

export class Routes extends React.Component {
  static matchSpecificPages(props) {
    const videos = [routes.videosList.path, routes.videosFilter.path];
    return videos.some((path) => matchPath(props.location.pathname, path));
  }

  loadForSpecificPages = () => {
    if (Routes.matchSpecificPages(this.props)) {
        // Videos
        this.props.actions.geodata.getCountriesForFilter();
        this.props.actions.geodata.getRegionsForFilter();
        this.props.actions.tags.getTags();
    }
  }

  static preload(props) {
    const preloadList = [
      props.actions.locales.getLocales(),
    ];

    return Promise.all(preloadList);
  }

  componentDidMount() {
    const {actions} = this.props;
    actions.locales.getTimezones();
    actions.geodata.getCountries();
    actions.user.getCurrentUser().then(() => {
      actions.user.checkPlanningAccess().catch(() => {});
    }).catch(err => {
      return err;
    });
    actions.tos.getToS();
    this.loadForSpecificPages();
  }

  componentDidUpdate(prevProps) {
    const isChangedLocales = this.props.common.locale !== prevProps.common.locale;

    if (isChangedLocales) {
      this.props.actions.tos.getToS();
      this.props.actions.geodata.getCountries();
      this.loadForSpecificPages();
    }

    if (
      Routes.matchSpecificPages(this.props) &&
      !Routes.matchSpecificPages(prevProps)
    ) {
      this.loadForSpecificPages();
    }
  }

  render() {
    const { location, common } = this.props;
    const { pathname, search } = location;
    const searchParams = new URLSearchParams(search);
    const plan = searchParams.get('plan');
    const isRuptlyPass =
      plan === 'ruptly-pass-monthly-eur' || plan === 'ruptly-pass-annually-eur';

    if (common.isIE) {
      return (
        <Switch>
          <Redirect exact from={`/${common.locale}`} to={`/${common.locale}/old-browsers`} />
          <Route {...routes.oldbrowsersView} />
        </Switch>
      )
    }

    return (
      <Switch>
        <Redirect exact from="/" to={`/${common.locale}`} />
        {common.notFound.map(path => (
          <Route key={path} path={path} {...routes.notFoundLive} />
        ))}
        <Route {...routes.dashboard} />
        <Route {...routes.landing} />
        <Route {...routes.signin} />
        <Route {...routes.signinDeactivated} />
        <Route {...routes.signup} />
        <Route {...routes.checkEmail} />
        <Route {...routes.alreadyConfirmed} />
        <Route {...routes.finalStep} />
        <Route {...routes.joinTeam} />
        <Route {...routes.restorePassword} />
        <Route {...routes.restorePasswordCheck} />
        <Route {...routes.newPassword} />
        <Route {...routes.newPasswordChanged} />
        <Route {...routes.livesList} />

        <PrivateRoute {...routes.myEventsList} />

        <Route {...routes.livesView} />
        <Route {...routes.videosFilter} />
        <Route {...routes.videosList} />
        <Route {...routes.videoView} />
        <Route {...routes.impressum} />

        <Route {...routes.listsView} />

        <PrivateRoute {...routes.user} />

        <Route {...routes.choosePlan} />
        <Route {...routes.requestPlan} />
        <Route {...routes.broadcast} />
        <Route {...routes.broadcastLocation} />

        <PrivateRoute
          {...routes.payment}
          ignorePrivate={
            pathname === `/${common.locale}/payment/subscription` &&
            isRuptlyPass
          }
        />

        <PrivateRoute {...routes.paymentProcessing} />

        <Route {...routes.oldbrowsersView} />
        <Route {...routes.about} />
        <Route {...routes.tos} />
        <Route {...routes.privacyPolicy} />
        <Route {...routes.cookiePolicy} />
        <Route {...routes.careersList} />
        <Route {...routes.careersView} />
        <Route {...routes.notFound} />
      </Switch>
    );
  }
}

export default withRouter(
  DI(['user', 'tos', 'locales', 'tags', 'geodata', 'releasenote'])(
    frontload(Routes, 'common')
  )
);
